import React from "react";
import "./Customers.css";

import THREEDIUM_LOGO from "../../assets/images/customer-logos/threedium.png";
import AIS_LOGO from "../../assets/images/customer-logos/ais.webp";
import EDILYTICS_LOGO from "../../assets/images/customer-logos/edilytics.jpeg";
import ERGOGENESIS_LOGO from "../../assets/images/customer-logos/ergo.webp";
import HBNS_LOGO from "../../assets/images/customer-logos/hbns.jpeg";
import HEWI_LOGO from "../../assets/images/customer-logos/hewi.png";
import MEDSTORK_LOGO from "../../assets/images/customer-logos/medstork.png";
import NEVOLI_LOGO from "../../assets/images/customer-logos/nevoli.png";
import ZOLL_LOGO from "../../assets/images/customer-logos/zoll.png";

const customers = [
  { name: "Threedium", image: THREEDIUM_LOGO },
  { name: "AIS", image: AIS_LOGO },
  { name: "Edilytics", image: EDILYTICS_LOGO },
  { name: "ErgoGenesis", image: ERGOGENESIS_LOGO },
  { name: "HBNS", image: HBNS_LOGO },
  { name: "HEWI", image: HEWI_LOGO },
  { name: "Medstork", image: MEDSTORK_LOGO },
  { name: "Nevoli", image: NEVOLI_LOGO },
  { name: "ZOLL", image: ZOLL_LOGO },
];

const Customers = () => {
  return (
    <section id="customers" className="section-tight">
      <div className="container">
        <p className="customers-label">trusted by teams at</p>
      </div>
      <div className="marquee" aria-hidden="true">
        <div className="marquee-track">
          {[...customers, ...customers].map((customer, i) => (
            <img
              key={`${customer.name}-${i}`}
              src={customer.image}
              alt={i < customers.length ? customer.name : ""}
              className="customer-logo"
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Customers;
